import Vue from 'vue';
import DatatableLoader from './datatable-loader.vue';

Vue.component('datatable-loader', DatatableLoader);
